import React, { useEffect, useState, useMemo } from 'react'
import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import ErrorAlert from '../Alerts/ErrorAlert';
import LoadingAlert from '../Alerts/LoadingAlert';
import ConfirmationAlert from '../Alerts/ConfirmationAlert';
import { PrinterFetchAPI } from '../../api/Printer';
import { MachinesFetchAPI } from '../../api/Machines';
import { AuthDgiFetchAPI } from '../../api/Paymentpost/AuthDgi';
import { PreOrderFetchAPI } from '../../api/Paymentpost/PreOrder';
import { CategriesPosFetchAPI } from '../../api/Paymentpost/CategoriesPos';
import { RequestLocalFetchAPI } from '../../api/Paymentpost/RequestLocal';
import { DeletedTempOrdersFetchAPI } from '../../api/DeletedTemporalOrders';
import { TablesFetchAPI } from '../../api/Tables';
import Select from 'react-select';
import AlertSmall from '../Alerts/AlertSmall';
//Utils
import { buildCloudinaryImageUrl } from '../../utils/CloudinaryImageUrl';
import { showApiError } from '../../utils/ApiError';
//IMG
import defaultImage from "../../assets/img/default.png";


function Modalblind({ showModalBind, setShowModalBind, shoppingCart, setShopingcartBind, shoppingCartCombos, setShopingcartComboBind, dataPreOrderBind, codeParthner, getAll, cleanStates, orderNumberNow, getOrderNumber }) {

    const [name, setName] = useState("");
    const [infoPrinter, setInfoPrinter] = useState({ printer_comanda: "", printer_ticket: "" })
    const [printers, setPrinters] = useState([]);
    const [dataOrder, setDataOrder] = useState({});
    const [tableNumber, setTableNumber] = useState(0);
    const [eventHandler, setEventHandler] = useState(0);
    const [selectedTable, setSelectedTable] = useState(null);
    const [tables, setTables] = useState([]);
    const [disabled, setDisabled] = useState(false);


    const [dataPreviewTotals, setDataPreviewTotals] = useState({ discount: 0, subtotal: 0, tax: 0, total: 0, taxesArray: [] })
    const [totalValid, setTotalValid] = useState(0)

    let title_modal = "Crear precuenta"
    let machine = JSON.parse(localStorage.getItem('machine'));
    let user = JSON.parse(localStorage.getItem('user'));
    let date = new Date().toJSON().slice(0, 10)


    const bindShoppingCart = () => {
        console.log("dataPreOrderBind> ", dataPreOrderBind);

        if (dataPreOrderBind.length > 1) {

            let orderValidDivide = 0
            dataPreOrderBind.forEach((data) => { if (data.justification == "Divide into parts") { orderValidDivide = 1 } })

            if (orderValidDivide == 1) {
                ErrorAlert("Hay una orden dividida por partes", "No es posible unir ordenes por partes", "warning")
            } else {
                let groups = []
                let combos = []
                let newName = ""
                dataPreOrderBind.forEach((order) => {
                    newName = newName + " / " + order.client_name
                    combos = combos.concat(order.combos)
                    groups = groups.concat(order.groups)
                })

                let groupsvalid = []
                let combovalid = []
                groups.forEach((group, index) => {
                    groupsvalid.push({ ...group, idPositionArrayNow: "" + group.group_id + index, segments_string: group.segments_string + " " + index });
                })

                combos.forEach((combo, index) => {
                    combovalid.push({ ...combo, idPositionArrayNow: "" + combo.combo_id + index });
                })


                console.log(newName + " (Unida)");
                setName(prev => newName + "(Unida)")
                setShopingcartBind(groupsvalid)
                setShopingcartComboBind(combovalid)
                calculateInvoiceTotals(groupsvalid, combovalid, 1)

                setShowModalBind(true)
            }
        } else {
            ErrorAlert("Debes seleccionar mas de un orden", "Error", "warning")
        }
    }

    // ====== CRUD branchoffice tables ======
    const getBranchofficeTables = async () => {
        let token = localStorage.getItem('x-access-machine-token');
        let branchoffice = JSON.parse(localStorage.getItem('branchoffice'))
        try {
            let response = await TablesFetchAPI.getBranchofficeTables(branchoffice?.id, token);
            // We set the tables
            setTables(response.data.tables.map(table => ({
                id: table.id,
                number: table.name,
                code: table.code,
                zone: table.branchoffice_environment_id,
            })));
        } catch (e) {
            setTables([]);
        }
    };

    // options for the table select using  react-select
    const tableOptions = useMemo(() => {
        return (tables || []).map(t => ({
            value: t.id,
            label: `${t.name ?? `Mesa ${t.number ?? t.code ?? t.id}`}${t.environment_name ? ` • ${t.environment_name}` : ""}`,
            raw: t, // We keep the raw table data for later use when a table is selected
        }));
    }, [tables]);

    const calculateInvoiceTotals = (products, combos, part) => {
        let taxesArray = [];
        let invoiceTotalDiscount = 0;
        let invoiceSubtotal = 0;
        let invoiceTotalItbms = 0;
        let invoiceTotal = 0;

        if ((products.length + combos.length) > 0) {
            combos.forEach((combo) => {
                byProductandCombo(combo);
            });
            products.forEach((group) => {
                byProductandCombo(group);
            });

            function byProductandCombo(item) {
                let product_info = item;
                let total_product_price = 0;
                let total_product_itbms = 0;
                let product_total_discount = 0;
                product_total_discount = (product_info.unit_discount * product_info.amount);
                total_product_price = (product_info.amount * (product_info.price - product_info.unit_discount));
                let taxesGroup = product_info.taxes;
                taxesGroup.forEach(tax => {
                    let valueTax = (product_info.amount * ((product_info.price - product_info.unit_discount) * tax.taxtValue));
                    tax.total = valueTax;
                    var index = taxesArray.findIndex(function (info, i) {
                        return info.tax_id === tax.tax_id;
                    });
                    if (index < 0) {
                        let taxInfoNow = {
                            "dTasaITBMSValue": tax.dTasaITBMSValue,
                            "percentage": tax.percentage,
                            "tax": tax.tax,
                            "tax_id": tax.tax_id,
                            "taxtValue": tax.taxtValue,
                            "total": valueTax
                        };
                        taxesArray.push(taxInfoNow);
                    } else {
                        taxesArray[index].total = (taxesArray[index].total + valueTax);
                    }
                    total_product_itbms = (total_product_itbms + valueTax);
                });
                invoiceTotalDiscount = invoiceTotalDiscount + product_total_discount;
                invoiceSubtotal = invoiceSubtotal + total_product_price;
                invoiceTotalItbms = invoiceTotalItbms + total_product_itbms;
                invoiceTotal = invoiceTotal + total_product_price + total_product_itbms;
            }

            setDataPreviewTotals({
                discount: parseFloat(invoiceTotalDiscount),
                subtotal: parseFloat(invoiceSubtotal),
                tax: parseFloat(invoiceTotalItbms),
                total: parseFloat(invoiceTotal),
                taxesArray: taxesArray
            });
            setTotalValid(parseFloat(invoiceTotal));
            setEventHandler(1);
        } else {
            // Si no hay productos ni combos, aseguramos que el estado se reinicie a cero
            setDataPreviewTotals({ discount: 0, subtotal: 0, tax: 0, total: 0, taxesArray: [] });
            setTotalValid(0);
        }
    }

    //Template card Group of setGroup
    const cardGroup = (product) => {
        return (
            <div className="card-group">
                <div className="card">
                    <div className='d-flex justify-constent- between'>
                        <img src={buildCloudinaryImageUrl({ url: product.img, width: 300, quality: "auto", type: "image" }) || defaultImage} loading='lazy' className='m-2' alt="..." width="50" height="50" />
                        <div className="card-body">
                            <h5 className="card-title">{product.name}</h5>
                            <p className="card-text">{product.description}</p>
                            <details close >
                                <summary className=''>
                                    <span className='badge bg-light text-dark summary-text-pos  fw-bold border rounded-4  text-wrap '>
                                        <i className="uil uil-info-circle  px-1 "></i>  Detalles
                                    </span>
                                </summary>
                                {product.segments.map(item => (
                                    <span className="badge bg-light text-dark  summary-text-pos m-2 border rounded-4 my-1 text-wrap ">
                                        {/* <span className='kiosk-subtitle-s' >   </span> */}
                                        <span className='text-muted m-0 p-0'>{item.segment_name ? item.segment_name : item.name}:</span>
                                        <br />
                                        <strong>
                                            <span className='me-2'>{item.name} </span>
                                            {item.price ? parseFloat(item.price).toFixed(2) : parseFloat(item.item.price).toFixed(2)}
                                        </strong>
                                    </span>
                                ))}
                            </details>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    const safeNewOrderBlind = async () => {
        setDisabled(true);
        if (isNaN(totalValid)) {
            ErrorAlert("", "No es posible unir las ordenes debido a un error en la estructura de los datos", "warning")
        } else {
            if (totalValid != null) {
                createPreOrder()
            } else {
                setDisabled(false)
                ErrorAlert("", "No es posible unir las ordenes debido a un error en la estructura de los datos", "warning")
            }

        }

    }

    //create preOrder
    const createPreOrder = async () => {
        let token = localStorage.getItem('x-access-machine-token');
        let branchoffice = JSON.parse(localStorage.getItem('branchoffice'))
        let machine = JSON.parse(localStorage.getItem('machine'))
        let user = JSON.parse(localStorage.getItem('user'));
        let newOrderNumber = await getOrderNumber(true);
        console.log("newOrderNumber", newOrderNumber);
        console.log("name", name);
        console.log("Totales en blind", dataPreviewTotals);

        let newName = "UNIDO: -" + name
        dataPreOrderBind.forEach((order) => {
            newName = newName + " / " + order.client_name
        })
        let json = {
            "client_name": newName,
            "localizador": "00",
            "table_name": tableNumber,
            "client_phone": "0",
            "ruc": 0,
            "dv": 0,
            "id_Client": 0,
            "dgi_qr": "0",
            "Orden": shoppingCart,
            "combos": shoppingCartCombos,
            "Descuento": parseFloat(dataPreviewTotals.discount),
            "discount": parseFloat(dataPreviewTotals.discount),
            "Total": parseFloat(dataPreviewTotals.total),
            "itbms": parseFloat(dataPreviewTotals.tax),
            "taxes": dataPreviewTotals.taxesArray,
            "subtotal": parseFloat(dataPreviewTotals.subtotal),
            "machine_id": machine.id,
            "transaction_code": newOrderNumber,
            "branchoffice_id": branchoffice.id,
            "tipoOrden": "comer aqui",
            "paymethod": 0,
            "is_discount_notification": false,
            "is_cupon": false,
            "is_devolution_notification": false,
            "is_pre_order": true, "user": {
                id: user.id,
                name: user.name,
                code: user.user_code
            }
        }

        if (selectedTable != null) {
            json.table_name = selectedTable.raw?.number || null
            json.table_id = selectedTable?.value || null
            json.table_code = selectedTable.raw?.code || null
        }

        try {
            const response = await PreOrderFetchAPI.createPreOrder(json, token)
            setDisabled(false)
            let message = "Precuenta creada con exito."
            let title = "Operacion exitosa."
            let icon = "success"

            dataPreOrderBind.forEach(async (order) => {
                await deletePreOrder(order.code, response.data.newTempOrder.code)
            })


            //ErrorAlert(message, title, icon);
            AlertSmall("Precuenta creada con exito", "success")
            setShowModalBind(false)
            cleanStates()

        } catch (err) {
            setDisabled(false)
            showApiError(err, {
                title: "No se pudo unir las precuentas",
                message: "El servidor no pudo crear la precuenta unificada.",
                context: `orders=${dataPreOrderBind.map(order => order.code).join(",")}`,
            }, ErrorAlert);
        }

    }

    //delete preorder
    const deletePreOrder = async (code, newOrderCode) => {
        LoadingAlert()
        let branchoffice = JSON.parse(localStorage.getItem('branchoffice'))
        let business = JSON.parse(localStorage.getItem('business'))
        let user = JSON.parse(localStorage.getItem('user'));
        let machine_token = localStorage.getItem('x-access-machine-token');

        let business_code = business.code
        let branch_code = branchoffice.code

        if (codeParthner != 0) {
            business_code = codeParthner.business_code
            branch_code = codeParthner.branchoffice_code
        }

        let ordersCodeblind = ""
        dataPreOrderBind.forEach((order) => { ordersCodeblind = " " + ordersCodeblind + " / " + order.code })
        let jsonUpdate = {
            "order_code": code,
            "business_code": business_code,
            "branchoffice_code": branch_code,
            "deleted": true,
            "justification": "Union de precuentas: " + ordersCodeblind + ". Nueva precuenta: " + newOrderCode,
            "status": 5,
            "user_id": user.id,
            "deleted_code": "UNION_PAY"
        }
        try {
            //We save the preorder
            await DeletedTempOrdersFetchAPI.newDeletedTempOrder(jsonUpdate, machine_token);
            //We delete the preorder
            await PreOrderFetchAPI.deletePreOrder(jsonUpdate, machine_token)
            let message = "precuenta eliminada con exito."
            let title = "Precuenta eliminada"
            let icon = "success"

            console.log("precuenta original eliminada");
            //ErrorAlert(message, title, icon)
            getAll();
        } catch (err) {
            showApiError(err, {
                title: "No se pudo eliminar la precuenta original",
                message: "Esta precuenta pertenece a otra sucursal o no se pudo eliminar.",
                context: `order_code=${code || ""} new_order=${newOrderCode || ""}`,
                icon: "warning",
            }, ErrorAlert);
        }
    }

    // view get order to return
    const cardGetOrder = () => {
        const cardOrder = shoppingCart.map((product) => (
            <>
                <div >
                    <div className="d-flex rounded m-1 bg-white mt-1 card-pos">
                        <div className="flex-shrink-0">
                            <img className='m-1 rounded  bg-light border ' loading='lazy' src={buildCloudinaryImageUrl({ url: product.img, width: 300, quality: "auto", type: "image" }) || defaultImage} width="42" height="42" />
                        </div>
                        <div className="flex-grow-1 m-1">
                            <div className="d-flex bd-highlight">
                                <div className="bd-highlight title-product-cart mt-1 text-dark fw-bold">
                                    {product.name}
                                </div>
                                <div className="ms-auto px-2 bd-highlight text-price-cart" translate='no'>
                                    $ {product.price.toFixed(2)}
                                </div>
                            </div>

                            <div className={`d-flex bd-highlight text-muted opacity-75 position-relative d-flex justify-content-between align-items-center`}>
                                <details open >
                                    <summary className=''>
                                        <span className='badge bg-light text-dark summary-text-pos  fw-bold border rounded-4  text-wrap '>
                                            <i className="uil uil-info-circle  px-1 "></i>  Detalles
                                        </span>
                                    </summary>
                                    {product.segments.map(item => (
                                        <span className="badge bg-light text-dark  summary-text-pos m-2 border rounded-4 my-1 text-wrap ">
                                            {/* <span className='kiosk-subtitle-s' >   </span> */}
                                            <span className='text-muted m-0 p-0'>{item.segment_name}:</span>
                                            <br />
                                            <strong>
                                                <span className='me-2'>{item.name} </span>
                                                {parseFloat(item.price).toFixed(2)}
                                            </strong>
                                        </span>
                                    ))}
                                </details>


                            </div>



                        </div>


                    </div>
                </div>
            </>
        ));
        return (cardOrder)
    }

    // view get order to return
    const cardGetOrderCombo = () => {
        const cardOrder = shoppingCartCombos.map((product) => (
            <>

                <div >
                    <div className="d-flex rounded m-1 bg-white mt-1 card-pos">
                        <div className="flex-shrink-0">
                            <img className='m-1 rounded  bg-light border ' loading='lazy' src={buildCloudinaryImageUrl({ url: product.img, width: 300, quality: "auto", type: "image" }) || defaultImage} width="42" height="42" />
                        </div>
                        <div className="flex-grow-1 m-1">
                            <div className="d-flex bd-highlight">
                                <div className="bd-highlight title-product-cart mt-1 text-dark fw-bold">
                                    {product.name}
                                </div>
                                <div className="ms-auto px-2 bd-highlight text-price-cart" translate='no'>
                                    $ {product.price.toFixed(2)}
                                </div>
                            </div>

                            <div className={``}>
                                {product.setGroups.map((setGroup) => (
                                    <div className="d-flex justify-content-between" key={setGroup.set_id}>
                                        <details close >
                                            <summary className=''>
                                                <span className='badge bg-light text-dark summary-text-pos  fw-bold border rounded-4  text-wrap m-1 '>
                                                    <i className="uil uil-info-circle  px-1 "> {setGroup.name}</i>
                                                </span>
                                            </summary>
                                            {setGroup.groups.map((group) => (<>
                                                {cardGroup(group)}
                                            </>))}
                                        </details>
                                    </div>))}
                            </div>



                        </div>


                    </div>
                </div>
            </>
        ));
        return (cardOrder)
    }




    // Sincroniza los totales cada vez que cambian los productos o combos
    useEffect(() => {
        calculateInvoiceTotals(shoppingCart, shoppingCartCombos, 1);
    }, [shoppingCart, shoppingCartCombos]);

    useEffect(() => {
        setEventHandler(0);
    }, [eventHandler, dataPreviewTotals]);

    useEffect(() => {
        getBranchofficeTables();
    }, []);

    return (
        <>

            <button className='btn bg-success-subtle text-success fw-bold border-0 ms-1 '
                onClick={() => (bindShoppingCart())}>
                <i class="uil uil-arrow-compress-h"></i>Unir Ordenes
            </button>


            <Modal
                show={showModalBind}
                size="xl"
                centered
                onHide={() => (setShowModalBind(false))}
            >

                <Modal.Body className='p-2' >
                    <section className='flex-container'>
                        <div className="d-flex justify-content-center border-bottom-0">
                            <h2 className="modal-title fw-bold fs-5">
                                <i className="uil uil-receipt"></i> Unir Ordenes
                            </h2>
                        </div>
                        <div className=' d-block d-lg-flex justify-content-lg-around'>

                            <div >
                                <span className='p-0  text-primary fw-bold'>Datos de Cliente </span>
                                <div className='d-flex  justify-content-between position-relative'>
                                    <div className=' border m-1 p-2 rounded-3  shadow-sm'>
                                        <small className="  fw-bold">Nombre</small>
                                        <small className="d-block text-center ">
                                            {dataOrder.client_name != name ? name : dataOrder.client_name}
                                        </small>
                                    </div>
                                    <div className=' border p-2 m-1 rounded-3 bg-white shadow-sm' >
                                        <small className=" text-center  text-dark  fw-bold">Mesa</small>
                                        <small className="d-block text-center">{tableNumber} </small>
                                    </div>
                                    <div className='d-block d-lg-inline border  p-2 m-1 rounded-3 bg-white shadow-sm' >
                                        <small className=" text-center  text-dark  fw-bold">Fecha</small>
                                        <small className="d-block text-center">{date} </small>
                                    </div>

                                    <div className=' border m-1 p-2 rounded-3  shadow-sm'>
                                        <small className="  fw-bold">Ordenes</small>
                                        <small className="d-block text-center ">
                                            {dataPreOrderBind.map((order) => (<> {order.transaction_code} / </>))}
                                        </small>
                                    </div>
                                </div>

                                <div className=' col-sm-12' >
                                    <div className=' border p-2 m-1 rounded-3 bg-white shadow-sm' >
                                        <small className=" text-center  text-dark  fw-bold">Mesa</small>
                                        <Select
                                            value={selectedTable}
                                            onChange={(opt) => { setSelectedTable(opt); setTableNumber(opt?.raw?.number) }}
                                            options={tableOptions}
                                            isClearable
                                            placeholder="Buscar mesa/stand..."
                                            noOptionsMessage={() => "No hay mesas que coincidan"}
                                        />
                                    </div>
                                </div>
                                <div className='d-flex justify-content-start mt-1'>
                                    <details className=''>
                                        <summary className='sumamary-text bg-primary-subtle primary-success
                         p-1 rounded-3'><i class="uil uil-edit"></i>
                                            Editar
                                        </summary>



                                        <div>
                                            <Form>
                                                <div className='row d-flex justify-content-center align-item-center'>
                                                    <Form.Group className="mb-3 " controlId="formBasicText">
                                                        <Form.Label >Ingresa un nombre</Form.Label>
                                                        <Form.Control placeholder={name} value={name} onChange={(e) => (setName(e.target.value))} />
                                                    </Form.Group>

                                                    {/*<Form.Group className="mb-3 " controlId="formBasicText">
                                                        <Form.Label >Ingresa el numero de la mesa</Form.Label>
                                                        <Form.Control placeholder={tableNumber} onChange={(e) => (setTableNumber(e.target.value))} />
                                                    </Form.Group>*/}





                                                </div>
                                            </Form>
                                        </div>


                                    </details>
                                </div>
                                <div className=''>
                                    <span className='p-0  text-primary fw-bold'>Totales </span>
                                    <div className="list-total-pre-order-modal row mx-1 justify-content-md-center
                           ">

                                        <small className='col-4 col-md-5 col-lg-12  border rounded text-center shadow-sm ' >
                                            <strong>Descuento</strong>
                                            <br />
                                            <span translate='no'>$ <span>{dataPreviewTotals.discount.toFixed(2)}</span></span> </small>
                                        <small className=' col-4 col-md-5 col-lg-12    border rounded text-center shadow-sm' >
                                            <strong>Impuestos</strong>
                                            <br />
                                            <span translate='no'>$ <span>{dataPreviewTotals.tax.toFixed(2)}</span></span> </small>
                                        <small className=' col-4  col-md-5 col-lg-12  border rounded text-center shadow-sm'>
                                            <strong> Subtotal</strong>
                                            <br />
                                            <span translate='no'>$ <span>{dataPreviewTotals.subtotal.toFixed(2)}</span></span></small>
                                        <div className='col-12 col-md-5 col-lg-12 shadow-sm    border rounded text-center' >
                                            <strong>Total</strong> <small className='text-muted'>(+Impuestos)</small>
                                            <div translate='no'>
                                                $ <span>{dataPreviewTotals.total.toFixed(2)}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                            <div className=''>
                                <div>
                                    <span className='p-0  text-primary fw-bold'>Lista de Productos de Orden </span>
                                    <div className='item2 list-pre-order-framer  border-inset bg-light-subtle border border-2 border-1 border-light-subtle rounded-3  align-self-center  '>
                                        {cardGetOrder()}
                                        {cardGetOrderCombo()}
                                    </div>

                                </div>

                            </div>

                        </div>
                    </section>

                    <div className='d-block mt-lg-1 mt-0'>
                        <div className='d-flex justify-content-end mt-2'>
                            <button className='btn bg-danger-subtle text-danger  border-0 fw-bold '
                                onClick={() => (setShowModalBind(false))}> Cancelar </button>


                            <button className='btn bg-success-subtle text-success fw-bold border-0  ms-2' onClick={() => safeNewOrderBlind()}
                                disabled={disabled}
                            > {disabled == true ? <>Uniendo precuenta...</>:<>Guardar union de ordenes</>}</button>


                        </div>
                    </div>





                </Modal.Body>
            </Modal>


        </>
    )
}

export default Modalblind
